import React, { Component } from "react";
import Button from "./Button";
class Jumbotron extends Component {
  render() {
    const jumbotronStyle = {
      paddingTop: "100px",
      paddingBottom: "100px",
      textAlign: "center"
    };
    const title = "G Suite";
    const quote =
      "Gmail, Docs, Drive et Agenda pour les entreprises";
    return (
      <section
        className="container"
        style={jumbotronStyle}
      >
        <div className="row justify-content-around align-items-center">
        <div className="col-12">
          <h1>{title}</h1>
          <p className="h3">{quote}</p>
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <Button href="#features"/>
        </div>
        </div>
      </section>
    );
  }
}

export default Jumbotron;
